import { render, staticRenderFns } from "./RecurrenceEvents.vue?vue&type=template&id=8e9c867e&"
import script from "./RecurrenceEvents.vue?vue&type=script&lang=js&"
export * from "./RecurrenceEvents.vue?vue&type=script&lang=js&"
import style0 from "./RecurrenceEvents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports